import { SettlementProcessor } from '../settlements.proccesor';
import { MarketDataProcessor } from '../market-data.processor';

// Definir una interfaz para los procesadores de documentos
export interface DocumentProcessor {
  transformData(data: any[]): Promise<any[]>;
  upload(data: any[], options?: any): Promise<any>;
}

export class DocumentProcessorFactory {
  static getProcessor(documentType: string): DocumentProcessor {
    switch (documentType) {
      case 'market_data':
        return MarketDataProcessor;
      case 'settlements':
        return SettlementProcessor;
      default:
        throw new Error(`Unsupported document type: ${documentType}`);
    }
  }
}
